


export class ModerationUserClass {
    constructor() {
        this.id = 0;
        this.action = "";
        this.uuid = "";
    }
}